import React, { Component, Fragment } from 'react';

import EmailReportConfigApi from 'apis/EmailReportConfig';
import Toaster from 'components/Toaster';
import { COMMENT_EMAIL_INTERVALS } from 'constants/index';
import BusinessApi from 'apis/Business';
import EmailConfig from 'components/emailConfig/ConfigureEmailView';

class CommentEmailReportConfig extends Component {
  constructor() {
    super();
    this.state = {
      id: '',
      email_interval: '',
      is_active: '',
      is_unsubscribed: '',
      report_type: '',
      business_name: '',
      userName: '',
      userRole: '',
    };
  }

  componentWillMount() {
    this.getEmailReportConfig();
  }

  configFetchSuccess = (data) => {
    const {
      email_interval,
      is_active,
      is_unsubscribed,
      report_type,
      user_name,
      user_role,
      business_name,
    } = data;
    this.setState({
      id: data.id,
      email_interval,
      is_active,
      is_unsubscribed,
      business_name,
      report_type,
      userName: user_name,
      userRole: user_role,
    });
  }

  getEmailReportConfig = () => {
    EmailReportConfigApi.getPersonalCommentEmailReportConfig()
      .then(({ data }) => {
        this.configFetchSuccess(data);
      })
      .catch(error => {
        console.log(error);
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Connection Error'
        );
      });
  }

  handleOnCheck = () => {
    this.setState(prevState => ({ is_active: !prevState.is_active }));
  }

  handleOnSelect = (emailInterval) => {
    this.setState({ email_interval: emailInterval });
  }

  updateEmailReportConfig = () => {
    const { id, email_interval, is_active, report_type } = this.state;

    EmailReportConfigApi.updateEmailReportConfig(id, email_interval, is_active)
      .then(({ data }) => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Email settings saved successfully'
        );
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Error while saving'
        );
      });
  }

  render() {
    const {
      is_active,
      email_interval,
      is_unsubscribed,
      business_name,
      userName,
      userRole,
    } = this.state;

    return (
      <div>
        <p>
          <h2>{business_name}</h2>
          Comment Email Reports help you stay updated with your customer's
          comments through email.
        <br />
          You can select and customize the comment email reports below.
      </p>
        <EmailConfig
          business_name={business_name}
          userName={userName}
          userRole={userRole}
          is_active={is_active}
          is_unsubscribed={is_unsubscribed}
          email_interval={email_interval}
          handleOnCheck={this.handleOnCheck}
          handleOnSelect={this.handleOnSelect}
          updateEmailReportConfig={this.updateEmailReportConfig}
          checkboxLabel="Turn on Comment Email Reports"
          intervals={COMMENT_EMAIL_INTERVALS}
          name="comment-report-email-config"
        />
      </div>
    );
  }
}

export default CommentEmailReportConfig;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/reports/CommentEmailReportConfig.js